<template>
  <basic-container>
    <div class="page-container">
      <div class="map-wrapper">
        <AMapLoader
          :options="mapOptions"
          @init="handleMapInit"
          @error="handleMapError"
          @on-load="onLoad"
        >
          <!-- <template v-slot="{ map, AMap }">
            <button @click="addMarker(map, AMap)">添加标记</button>
          </template> -->
        </AMapLoader>
      </div>
    </div>
  </basic-container>
</template>

<script>
import AMapLoader from "./AMapLoader.vue";

export default {
  props: {
    gps: String,
    detail: String,
  },
  data() {
    return {
      mapOptions: {
        key: "5f33db47cfb7f326432a048a17e30705",
        version: "2.0",
        plugins: ["AMap.ToolBar", "AMap.Scale"],
        mapOptions: {
          zoom: 15,
          center: [],
          viewMode: "3D",
        },
      },
      data: [],
    };
  },
  components: { AMapLoader },
  created() {
    const gps = this.$route.query.gps;
    const detail = this.$route.query.detail;
    const name = this.$route.query.name;
    const date = this.$route.query.date;
    const type = this.$route.query.type;
    this.mapOptions.name = name;
    this.mapOptions.date = date;
    this.mapOptions.datail = detail;
    this.mapOptions.type = type;

    if (gps) {
      const [lng, lat] = gps.split(",").map(Number);
      if (!isNaN(lng) && !isNaN(lat)) {
        this.center = [lng, lat];
        // 更新地图选项的中心点
        this.mapOptions.mapOptions.center = this.center;
      }
    }
  },
  methods: {
    onLoad() {},

    handleMapInit({ map, AMap }) {
      console.log("地图初始化");
      this.mapInstance = map; // 保存地图实例
      map.addControl(new AMap.ToolBar());
      map.addControl(new AMap.Scale());

      // 添加标记点
      this.addMarker(map, AMap);
    },

    handleMapError(error) {
      console.error("地图加载错误:", error);
      alert("地图加载失败，请刷新重试");
    },

    addMarker(map, AMap) {
      if (!map || !AMap) return;
      const center = this.mapOptions.mapOptions.center;
      const marker = new AMap.Marker({
        position: center,
        map: map,
      });
      console.log(marker);

      const detail = this.$route.query.detail ? this.$route.query.detail : "";

      const infoWindow = new AMap.InfoWindow({
        content: `<div style="padding:5px; ">${detail}</div>`,
        offset: new AMap.Pixel(0, -30),
      });
      infoWindow.open(map, center);

      this.data.info = "123";
    },
  },
};
</script>

<style>
.page-container {
  padding: 0px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0; /* 清除默认外边距 */
  box-sizing: border-box; /* 确保 padding 不会增加总高度 */
  overflow: hidden; /* 添加这行 */
}

.map-wrapper {
  flex: 1;
  min-height: 0; /* 重要：修复Flexbox子元素溢出问题 */
}
</style>
